module.exports = __webpack_public_path__ + "static/media/play-base-icon.1135fa04.png";